import { render } from "./BasePageSpecialisee.vue?vue&type=template&id=768969e4&scoped=true"
import script from "./BasePageSpecialisee.vue?vue&type=script&lang=js"
export * from "./BasePageSpecialisee.vue?vue&type=script&lang=js"

import "./BasePageSpecialisee.vue?vue&type=style&index=0&id=768969e4&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768969e4"]])

export default __exports__